// mobile hamburger menu
var siteNavToggle = document.querySelector('.mobile-nav-toggle'),
    siteNav = document.querySelector('.ck-nav');
    
function toggleMenu(){
    siteNavToggle.classList.toggle('active');
    siteNav.classList.toggle('active');

    if(siteNav.classList.contains('active')){
		var navHeight = siteNav.scrollHeight;
		siteNav.style.maxHeight = navHeight+'px';
	}else{
		siteNav.style.maxHeight = '';
	}
}

siteNavToggle.addEventListener('click', function(e) {
    toggleMenu();

    e.preventDefault();
});